import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { useSelector } from 'react-redux';

import { useGame } from '../../../../context';
import { getRegionScore } from './selectors';

const useStyles = createUseStyles({
  bar: {
    borderRadius: 2,
    composes: ['is-relative', 'no-overflow'],
    height: 4,
    width: '70%',
  },
  progress: {
    composes: ['flex-columns', 'flex-between', 'items-center', 'is-full-width'],
  },
  score: {
    '&.completed': { fontWeight: 'bold' },
    borderRadius: 12,
    composes: ['text-center', 'fs10'],
    height: 24,
    lineHeight: 2.4,
    width: 60,
  },
  thumb: {
    '&.completed': { background: '#FFAE49' },
    background: '#393939',
    composes: ['is-overlay'],
    transition: 'right 0.3s',
    zIndex: 1,
  },
  track: {
    composes: ['is-overlay'],
    zIndex: 0,
  },
});

const RegionProgressComponent = React.memo(({ id, isopened }) => {
  const classes = useStyles();
  const { collectibles } = useGame();

  const percentage = useSelector(_ => getRegionScore(_, id, collectibles));
  const { completed, count, percent, score, total } = percentage;

  return (
    <div className={classes.progress}>
      <div className={classes.bar}>
        <div
          className={classnames(
            classes.track,
            'smart-maps-trophies-region-track'
          )}
        />
        <div
          className={classnames(classes.thumb, { completed })}
          style={{ right: `${score}%` }}
        />
      </div>
      <div
        className={classnames(
          classes.score,
          { completed },
          'smart-maps-trophies-region-score'
        )}>
        {!isopened && <span>{`${percent}%`}</span>}
        {isopened && (
          <span>
            {count}/{total}
          </span>
        )}
      </div>
    </div>
  );
});

RegionProgressComponent.propTypes = {
  id: PropTypes.string.isRequired,
  isopened: PropTypes.bool.isRequired,
};

RegionProgressComponent.displayName = 'RegionProgressComponent';

export default RegionProgressComponent;
